module.exports = __webpack_public_path__ + "static/media/ColumnCellFlotation_4.a72953d9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/simulator/ColumnCellFlotation_4.jpg
// module id = 424
// module chunks = 0